// Utilities
import React, { useEffect, useState } from "react";
import cookie from "react-cookies";
// import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { saveUser } from "../Redux/Actions/userActions";
import { updateInfo } from "../Request/UserRequests";
import { Link } from "react-router-dom";
// Popups
import Login from "./Login";
import SignUp from "./SignUp";
import Verify from "./Verify";
import ViaPin from "./ViaPin";

// banner img
import bg from "../img/LOGO.webp";
import { useNavigate } from "react-router";

function Main() {
  // const { t } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector((s) => s.user.info);
  // const [load, setLoad] = useState(false);
  const [language, setLanguage] = useState("en");
  const [phn, setPhn] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (cookie.load("uid") || cookie.load("visitor")) navigate("/home");
  }, [navigate]);

  useEffect(() => {
    document.body.style.backgroundColor = "#fff";
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.backgroundColor = "#fff";
      document.body.style.overflow = "auto";
    };
  }, []);
  useEffect(() => {
    if (user) {
      setLanguage(user.language);
      i18next.changeLanguage(user.language);
    }
  }, [user]);

  function LanguageChange(lang) {
    let change = {};

    change.language = lang;

    //console.log(change)
    dispatch(saveUser({ ...user, ...change }));
    // updateInfo(change)
    // 	.then((res) => {
    // 		dispatch(saveUser({ ...user, ...change }))
    // 	})
    // 	.catch((err) => console.log(err))
    // 	.finally(() => setLoad(false))

    setLanguage(lang);
    i18next.changeLanguage(lang);
  }

  function handleFocus() {
    document.getElementById("phoneNo").focus();
  }

  return (
    <>
      <div
        id="splash"
        style={{
          position: "fixed",
          zIndex: "9999",
          top: "0",
          left: "0",
          bottom: "0",
          width: "100vw",
          overflow: "hidden",
          background: "#fff",
          transition: "ease 0.4s",
        }}
      >
        <div
          className="splash"
          style={{
            position: "relative",
            zIndex: "999",
            width: "150%",
            left: "-25%",
            background: "linear-gradient(180deg, #9C2F46 0%, #D66167 100%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src={bg} alt="" style={{ width: "124px" }} />
          <h1
            className="brandTitile"
            style={{
              fontSize: "24px",
              fontWeight: "700",
              textAlign: "center",
              margin: "8px 0 0",
              color: "#fff",
            }}
          >
            Rashan
          </h1>
        </div>
        <div
          style={{
            position: "relative",
            zIndex: "999",
            background: "#fff",
            height: "60vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h1
            style={{
              fontSize: "24px",
              fontWeight: "700",
              textAlign: "center",
              margin: "0 0 15px",
              color: "#2B2B2B",
            }}
          >
            Select Language
          </h1>
          <div style={{ width: "182px" }}>
            <a
              href="#"
              className="d-block p-2 btn-default-orange"
              key={2}
              onClick={() => {
                LanguageChange("en");
                document
                  .getElementById("splash")
                  .classList.toggle("splashhide");
                handleFocus();
              }}
            >
              English
            </a>
            <a
              href="#"
              className="d-block p-2 btn-default-orange mt-2"
              key={1}
              onClick={() => {
                LanguageChange("hi");
                document
                  .getElementById("splash")
                  .classList.toggle("splashhide");
                handleFocus();
              }}
            >
              हिन्दी
            </a>
            {/* <a
              href="#"
              className="d-block p-2 btn-default-orange mt-2"
              key={2}
              onClick={() => {
                LanguageChange("pa");
                document
                  .getElementById("splash")
                  .classList.toggle("splashhide");
                handleFocus();
              }}
            >
              ਪੰਜਾਬੀ
            </a> */}
            {/* <a
              href="#"
              className="d-block p-2 btn-default-orange mt-2"
              key={2}
              onClick={() => {
                LanguageChange("ud");
                document
                  .getElementById("splash")
                  .classList.toggle("splashhide");
                handleFocus();
              }}
            >
              اردو
            </a> */}
          </div>

          <div
            style={{
              display: "block",
              padding: "40px 15px 30px",
              lineHeight: "20px",
            }}
          >
            <p
              style={{
                fontSize: "12px",
                fontWeight: "600",
                color: "#2278FF",
                margin: "0",
              }}
            >
              <Link
                to="aboutUs"
                style={{
                  textDecoration: "none",
                  fontWeight: "500",
                  color: "#2278FF",
                  padding: "0 4px",
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
              >
                About Us
              </Link>
              |
              <Link
                to="termsCondition"
                style={{
                  textDecoration: "none",
                  fontWeight: "500",
                  color: "#2278FF",
                  padding: "0 4px",
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
              >
                Terms &amp; Conditions
              </Link>
              |
              <Link
                to="privacyPolicy"
                style={{
                  textDecoration: "none",
                  fontWeight: "500",
                  color: "#2278FF",
                  padding: "0 4px",
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
              >
                Privacy Policy
              </Link>
            </p>
          </div>
        </div>
      </div>
      <ViaPin />
      <Login phn={phn} setPhn={setPhn} />
      <Verify phn={phn} />
      <SignUp phn={phn} />
    </>
  );
}

export default Main;
